/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface ParamsProps {
  idLeadCorretor: string | null;
  nomeLead: string | null;
  telefoneLead: string | null;
  emailLead: string | null;
  cepLead: string | null;
  bairroResidencial: string | null;
  idBairroComercial: string | null;
  idEmpresaVenda: string | null;
  nomeEmpresaVenda: string | null;
  idCorretorOrigem: string | null;
  idCorretorAtendimento: string | null;
  nomeCorretorParceiro: string | null;
  idEmpreendimento: string | null;
  idLocalVenda: string | null;
  idCanalSistemaOrigem: string | null;
  idTipoAtendimento: string | null;
  dataHoraVisita: string | null;
  nomeCorretorOrigem: string | null;
}

export function useCadastrarAtendimento(body: ParamsProps) {
  const registerData = async () => {
    const CADASTRAR_ATENDIMENTO = `${leadsWebEnviroment}/app-web/atendimentos/v1`;
    return await instance.post(CADASTRAR_ATENDIMENTO, body);
  };
  const query = useMutation({
    mutationFn: async () => await registerData(),
    mutationKey: ["cadastrar_atendimento"],
    onError: (error: any) => {
      const notifications = error?.response?.data?.notifications;
      let errorMessages: string[];

      if (Array.isArray(notifications)) {
        const mensagemNotification = notifications.find(
          (item: any) => item?.key === "Mensagem"
        );

        if (mensagemNotification) {
          errorMessages = [`\n${mensagemNotification.message}\n`];
        } else {
          errorMessages = notifications.map(
            (item: any) => `\n${item?.message}\n`
          );
        }
      } else {
        errorMessages = ["\nErro desconhecido ao cadastrar atendimento\n"];
      }

      toast.error(errorMessages.join(""), { autoClose: 10000 });
    },
  });
  return query;
}
